/** Number of catalog items requested per page. */
export const CATALOG_PAGE_SIZE = 24;

/** Total number of pages needed to display `total` items at `pageSize` each. */
export function catalogPageCount(total: number, pageSize: number): number {
  if (pageSize <= 0) return 0;
  return Math.ceil(total / pageSize);
}
